import { type } from 'arktype';

export const GlobalRouteSearchParamSchema = type({
  'ref?': 'string',
  'action?': type("'logout'").or(type("'force_logout'")),
  'redirect?': 'string',
});
